import { DataTableImage } from "@appretio/ui-kit";
import { ColDef } from "ag-grid-enterprise";
import { activeDeactivateCellRenderer } from "./cellRenderComponent/activateDeactivateCellRender";
import { getSizeCurveSparklineParamsSizeCurve } from "./cellRenderComponent/cellRenderHelpers";

export const columnDefs: ColDef[] = [
  {
    headerName: "Style Option ID",
    field: "style_option_id_mockup",
    rowGroup: true,
    enableRowGroup: true,
    hide: true,
    aggFunc: "first",
    colId: "style_option_id_mockup",
    suppressSizeToFit: true,
    pinned: "left"
  },
  {
    headerName: "Image",
    field: "appretio_thumbnail_url",
    filter: "agMultiColumnFilter",
    cellRenderer: DataTableImage,
    aggFunc: "first",
    colId: "appretio_thumbnail_url",
    hide: false,
    suppressSizeToFit: true,
    pinned: "left"
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "style name",
    field: "style_name",
    aggFunc: "first",
    colId: "style_name",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "style category",
    field: "style_category",
    aggFunc: "first",
    colId: "style_category",
    hide: false,
    pinned: "left"
  },
  {
    filter: "agMultiColumnFilter",
    type: "activation",
    cellRenderer: activeDeactivateCellRenderer,
    cellStyle: {
      textAlign: "center"
    },
    headerName: "Activation (new)",
    field: "is_active",
    aggFunc: "sum",
    colId: "is_active",
    hide: false,
    pinned: "right"
  },
  {
    filter: "agMultiColumnFilter",
    type: "activation",
    cellRenderer: activeDeactivateCellRenderer,
    cellStyle: {
      textAlign: "center"
    },
    headerName: "Playbook State",
    field: "is_active_playbook",
    aggFunc: "sum",
    colId: "is_active_playbook",
    hide: false,
    pinned: "right"
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "business model group",
    field: "business_model_group",
    aggFunc: "first",
    cellStyle: {
      color: "dodgerblue"
    },
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Sales Location",
    field: "sales_location",
    enableRowGroup: true,
    colId: "sales_location",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Country",
    field: "country",
    hide: false,
    pinned: "left"
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Fulfillment Option",
    field: "fulfillment_model",
    hide: false,
    pinned: "left"
  },

  {
    filter: "agDateColumnFilter",
    headerName: "Last Changed Activation",
    filterParams: {
      buttons: ["apply", "reset"]
    },
    hide: true, //From first dataset, colId = "0",
    pinned: "right"
  },
  {
    filter: "agDateColumnFilter",
    headerName: "Last Changed Markdown",
    field: "event_date",
    filterParams: {
      buttons: ["apply", "reset"]
    },
    colId: "event_date",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Markdown % (new)",
    field: "markdown_percentage",
    cellRenderer: "agAnimateShowChangeCellRenderer",
    editable: true,
    colId: "markdown_percentage",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Markdown % (current)",
    field: "markdown_percentage_is_integrated",
    colId: "markdown_percentage_is_integrated",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Available Quantity",
    field: "quantity_available",
    aggFunc: "first",
    colId: "quantity_available",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Rating",
    headerTooltip:
      "BUY: Buy more units.HOLD: No action needed. CLEAR: Clear stock",
    hide: false,
    colId: "1",
    pinned: "right"
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "style option number",
    field: "style_option_number",
    aggFunc: "first",
    hide: true
  },

  {
    filter: "agMultiColumnFilter",
    headerName: "style number",
    field: "style_number",
    aggFunc: "first",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "style brand",
    field: "style_brand",
    aggFunc: "first",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "style subbrand",
    field: "style_subbrand",
    aggFunc: "first",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "style product line",
    field: "style_product_line",
    aggFunc: "first",
    colId: "style_product_line",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "style subcategory",
    field: "style_subcategory",
    aggFunc: "first",
    cellStyle: {
      color: "dodgerblue"
    },
    colId: "style_subcategory",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RRP EUR",
    field: "style_recommended_retail_price_eur",
    aggFunc: "first",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GS II AUR",
    field: "GS2_AUR",
    cellClass: "numberType",
    colId: "GS2_AUR",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "NS III AUR",
    field: "NS3_AUR",
    cellClass: "numberType",
    colId: "NS3_AUR",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RETURN RATE",
    field: "RETURN_RATE",
    cellClass: "numberType",
    colId: "RETURN_RATE",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RETURN RATE L4W",
    cellClass: "numberType",
    colId: "RETURN_RATE_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RETURN RATE L8W",
    field: "RETURN_RATE_8",
    cellClass: "numberType",
    colId: "RETURN_RATE_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RETURN RATE Lifetime",
    field: "RETURN_RATE_lifetime",
    cellClass: "numberType",
    colId: "RETURN_RATE_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II",
    field: "op_cm2",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "op_cm2",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II L4W",
    field: "op_cm2_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "op_cm2_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II L8W",
    field: "op_cm2_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "op_cm2_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II Lifetime",
    field: "op_cm2_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "op_cm2_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II MARGIN %",
    field: "CM2_MARGIN_PERCENTAGE",
    cellClass: "numberType",
    colId: "CM2_MARGIN_PERCENTAGE",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II MARGIN % L4W",
    field: "CM2_MARGIN_PERCENTAGE_4",
    cellClass: "numberType",
    colId: "CM2_MARGIN_PERCENTAGE_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II MARGIN % L8W",
    field: "CM2_MARGIN_PERCENTAGE_8",
    cellClass: "numberType",
    colId: "CM2_MARGIN_PERCENTAGE_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM II MARGIN % Lifetime",
    field: "CM2_MARGIN_PERCENTAGE_lifetime",
    cellClass: "numberType",
    colId: "CM2_MARGIN_PERCENTAGE_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs II od",
    field: "gs2_od",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs2_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs II od L4W",
    field: "gs2_od_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs2_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs II od L8W",
    field: "gs2_od_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs2_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs II od Lifetime",
    field: "gs2_od_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs2_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gis I od",
    field: "gis1_od",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "gis1_od",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gis I od L4W",
    field: "gis1_od_4",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "gis1_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gis I od L8W",
    field: "gis1_od_8",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "gis1_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gis I od Lifetime",
    field: "gis1_od_lifetime",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "gis1_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "ns III od",
    field: "ns3_od",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "ns3_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "ns III od L4W",
    field: "ns3_od_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "ns3_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "ns III od L8W",
    field: "ns3_od_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "ns3_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "ns III od Lifetime",
    field: "ns3_od_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "ns3_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "nis III od",
    field: "nis3_od",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "nis3_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "nis III od L4W",
    field: "nis3_od_4",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "nis3_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "nis III od L8W",
    field: "nis3_od_8",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "nis3_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "nis III od Lifetime",
    field: "nis3_od_lifetime",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "nis3_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "EOP Units",
    field: "stock_units_total",
    aggFunc: "max",
    colId: "stock_units_total",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RATE OF NET SALES",
    field: "RATE_OF_NET_SALES",
    sortingOrder: ["desc", "asc", null],
    sort: "desc",
    sortIndex: 0,
    cellClass: "numberType",
    colId: "RATE_OF_NET_SALES",
    aggFunc: null,
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RATE OF NET SALES L4W",
    field: "RATE_OF_NET_SALES_4",
    cellClass: "numberType",
    colId: "RATE_OF_NET_SALES_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RATE OF NET SALES L8W",
    field: "RATE_OF_NET_SALES_8",
    cellClass: "numberType",
    colId: "RATE_OF_NET_SALES_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RATE OF NET SALES Lifetime",
    field: "RATE_OF_NET_SALES_lifetime",
    cellClass: "numberType",
    colId: "RATE_OF_NET_SALES_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "NWC",
    field: "NWC",
    cellClass: "numberType",
    colId: "NWC",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Seasonality",
    field: "seasonality",
    aggFunc: "first",
    cellRenderer: "agSparklineCellRenderer",
    valueGetter: (params) =>
      params.data.seasonality ? params.data.seasonality : undefined,
    colId: "seasonality",
    hide: false
  },

  {
    filter: "agMultiColumnFilter",
    headerName: "Next In-delivery Date",
    field: "next_indelivery",
    aggFunc: "first",
    colId: "next_indelivery",
    hide: true,
    pinned: "left"
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Units in Next In-delivery",
    field: "next_indelivery_units",
    aggFunc: "first",
    colId: "next_indelivery_units",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Outstanding Units Total",
    field: "outstanding_units_total",
    aggFunc: "first",
    colId: "outstanding_units_total",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Outstanding At Cost Total",
    field: "outstanding_at_cost_total",
    aggFunc: "first",
    colId: "outstanding_at_cost_total",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM I",
    field: "op_cm1",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "op_cm1",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs I od",
    field: "gs1_od",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs1_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogr od",
    field: "cogr_od",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogr_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogs od",
    field: "cogs_od",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogs_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gr II od",
    field: "gr2_od",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gr2_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gir od",
    field: "gir_od",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gir_od",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs I od L4W",
    field: "gs1_od_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs1_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs I od L8W",
    field: "gs1_od_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs1_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gs I od Lifetime",
    field: "gs1_od_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gs1_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogr od L4W",
    field: "cogr_od_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogr_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogr od L8W",
    field: "cogr_od_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogr_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogr od Lifetime",
    field: "cogr_od_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogr_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogs od L4W",
    field: "cogs_od_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogs_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogs od L8W",
    field: "cogs_od_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogs_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "cogs od Lifetime",
    field: "cogs_od_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "cogs_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gr II od L4W",
    field: "gr2_od_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gr2_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gr II od L8W",
    field: "gr2_od_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gr2_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gr II od Lifetime",
    field: "gr2_od_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gr2_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gir od L4W",
    field: "gir_od_4",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gir_od_4",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gir od L8W",
    field: "gir_od_8",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gir_od_8",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "gir od Lifetime",
    field: "gir_od_lifetime",
    aggFunc: "sum",
    cellClass: "numberType",
    colId: "gir_od_lifetime",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "CM I MARGIN %",
    field: "CM1_MARGIN_PERCENTAGE",
    cellClass: "numberType",
    colId: "CM1_MARGIN_PERCENTAGE",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GS I AUC",
    field: "GS1_AUC",
    cellClass: "numberType",
    colId: "GS1_AUC",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GS I AUR",
    field: "GS1_AUR",
    cellClass: "numberType",
    colId: "GS1_AUR",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GS II AUC",
    field: "GS2_AUC",
    cellClass: "numberType",
    colId: "GS2_AUC",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GS II DISCOUNT %",
    field: "GS2_DISCOUNT_PERCENTAGE",
    cellClass: "numberType",
    colId: "GS2_DISCOUNT_PERCENTAGE",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GS II MARGIN %",
    field: "GS2_MARGIN_PERCENTAGE",
    cellClass: "numberType",
    colId: "GS2_MARGIN_PERCENTAGE",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GS II MARGIN VALUE",
    field: "GS2_MARGIN_VALUE",
    cellClass: "numberType",
    colId: "GS2_MARGIN_VALUE",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "NS III AUC",
    field: "NS3_AUC",
    cellClass: "numberType",
    colId: "NS3_AUC",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "NS III DISCOUNT %",
    field: "NS3_DISCOUNT_PERCENTAGE",
    cellClass: "numberType",
    colId: "NS3_DISCOUNT_PERCENTAGE",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "NS III MARGIN %",
    field: "NS3_MARGIN_PERCENTAGE",
    cellClass: "numberType",
    colId: "NS3_MARGIN_PERCENTAGE",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "NS III MARGIN VALUE",
    field: "NS3_MARGIN_VALUE",
    cellClass: "numberType",
    colId: "NS3_MARGIN_VALUE",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "COUNT UNIQUE",
    field: "COUNT_UNIQUE",
    cellClass: "numberType",
    colId: "COUNT_UNIQUE",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "COUNT BY COUNTRY LOCATION",
    field: "COUNT_BY_COUNTRY_LOCATION",
    cellClass: "numberType",
    colId: "COUNT_BY_COUNTRY_LOCATION",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RATE OF SALES BEFORE STOCKOUT",
    field: "RATE_OF_SALES_BEFORE_STOCKOUT",
    cellClass: "numberType",
    colId: "RATE_OF_SALES_BEFORE_STOCKOUT",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "RATE OF GROSS SALES",
    field: "RATE_OF_GROSS_SALES",
    cellClass: "numberType",
    colId: "RATE_OF_GROSS_SALES",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "eop at cost",
    field: "eop_at_cost",
    cellClass: "numberType",
    colId: "eop_at_cost",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "eop at cost ld",
    field: "eop_at_cost_ld",
    cellClass: "numberType",
    colId: "eop_at_cost_ld",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "eop at full price retail",
    field: "eop_at_full_price_retail",
    cellClass: "numberType",
    colId: "eop_at_full_price_retail",
    hide: true
  },

  {
    filter: "agMultiColumnFilter",
    headerName: "GWC",
    field: "GWC",
    cellClass: "numberType",
    colId: "GWC",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "rebuy qty before stockout",
    field: "rebuy_qty_before_stockout",
    cellClass: "integerType",
    colId: "rebuy_qty_before_stockout",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Weeks Until Next In-Delivery",
    field: "weeks_distance_until_next_indelivery",
    aggFunc: "first",
    colId: "weeks_distance_until_next_indelivery",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Markdown Currency",
    field: "currency_code",
    colId: "currency_code",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "First In-delivery Date",
    field: "first_indelivery",
    aggFunc: "first",
    colId: "first_indelivery",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Weeks Since Last In-Delivery",
    field: "weeks_since_last_indelivery",
    aggFunc: "first",
    colId: "weeks_since_last_indelivery",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "First In-delivery Age Category",
    field: "first_indelivery_age_category",
    aggFunc: "first",
    colId: "first_indelivery_age_category",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Last In-delivery Age Category",
    field: "last_indelivery_age_category",
    aggFunc: "first",
    colId: "last_indelivery_age_category",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Week Count",
    field: "week_count",
    aggFunc: "max",
    colId: "week_count",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Received Units",
    field: "received_units",
    aggFunc: "first",
    colId: "received_units",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "AUC",
    field: "edi_gross_price_eur",
    aggFunc: "avg",
    cellClass: "numberType",
    colId: "edi_gross_price_eur",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "AUC LD",
    field: "line_discounted_cost_eur",
    aggFunc: "avg",
    cellClass: "numberType",
    colId: "line_discounted_cost_eur",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "bulk value",
    field: "bulk_value",
    cellClass: "numberType",
    colId: "bulk_value",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "rebuy nwc",
    field: "rebuy_nwc",
    cellClass: "bg-secondary bg-opacity-50",
    aggFunc: "first",
    colId: "rebuy_nwc",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "rebuy qty",
    field: "rebuy_qty",
    cellClass: "integerType",
    colId: "rebuy_qty",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "GIS1 Before Stockout",
    field: "gis1_od_style_option",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "gis1_od_style_option",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "NIS3 Before Stockout",
    field: "nis3_od_style_option",
    aggFunc: "sum",
    cellClass: "integerType",
    colId: "nis3_od_style_option",
    hide: true
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Weeks Before Stockout",
    field: "weeks_before_stockout",
    aggFunc: "avg",
    cellClass: "numberType",
    colId: "weeks_before_stockout",
    hide: false
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Size Curve",
    field: "size_curve",
    aggFunc: "first",
    valueGetter: (params) => params.data?.size_curve || [],
    cellRenderer: "agSparklineCellRenderer",
    cellRendererParams: getSizeCurveSparklineParamsSizeCurve,
    headerTooltip:
      "Red sizecurve indicates that there is a stockout in the group.",
    colId: "size_curve"
  },

  {
    filter: "agMultiColumnFilter",
    headerName: "Stockout",
    aggFunc: "max",
    field: "stockout",
    colId: "stockout",
    hide: true
  },

  {
    filter: "agMultiColumnFilter",
    headerName: "Population Size",
    field: "population_size",
    aggFunc: "first",
    cellClass: "integerType",
    colId: "population_size",
    hide: true
  }
];
